import { Injectable } from '@angular/core'
import { AuthenticatedUser } from '../../interfaces/user.interface'

declare global {
  interface Window {
    BlatOut?: BlatOut;
  }
}

export interface BlatOut {
  load(config: any): void;
  open(): void;
  close(): void;
  refresh(): void;
}

@Injectable({
  providedIn: 'root'
})
export class BlatOutService {
  public async load(user: AuthenticatedUser | null): Promise<void> {
    if(!user) return

    window.BlatOut?.load({
      app: {
        id: '65e5470c-8cf1-44f1-ab1b-1959af90e966',
        title: 'Fieldnews - O boletim de novidades do Field Control',
      },
      user: {
        id: user.id,
        hash: user.fieldNewsEmailHash,
        email: user.email,
        name: user.name
      },
      widgets: {
        badge: {
          type: 'counter',
          selector: '#blatout-badge-counter'
        }
      }
    })
  }

  public refresh(): void {
    window.BlatOut?.refresh()
  }

  public open(): void {
    window.BlatOut?.open()
  }

}
